import { ColDef, ColumnApi, GridApi, ValueGetterParams } from 'ag-grid-community';
import { useEffect, useState } from 'react'
import { Contact } from '../../models/conversations';
import GridComponent from "../shared/grid";
import SettingsHeader from './settingsHeader.component';
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';
import { UtilityService } from '../../services/UtilityService';

interface Props {
}

const UnsubscribedContacts = (props: Props) => {
	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
	const GetUnSubscribedContacts: Contact[] = useSelector(selector.getUnSubscribedContacts)
	const [gridApi, SetGridApi] = useState<GridApi>(null)
	const [columnApi, SetColumnApi] = useState<ColumnApi>(null)
	const count = GetUnSubscribedContacts.length

	const UnsubscribedColoumnDefs: ColDef[] = [
		{
			field: "",
			headerName: "S.No",
			valueGetter: (params: ValueGetterParams) => {
				return params.node.rowIndex + 1
			},
			// headerCheckboxSelection: IsMobileDevice ? false : true,
			// checkboxSelection: IsMobileDevice ? false : true,
			maxWidth: 100
		},
		{
			field: "Name",
			headerName: "Name",
			valueGetter: (params: ValueGetterParams) => {
				return !!params.data.Name ? params.data.Name : '--'
			},
		},
		{
			field: "MaskedPhoneNumber",
			headerName: "Phone Number",
			valueFormatter: (params) => {
				return UtilityService.maskPhoneNumberOnLength(params.data.MaskedPhoneNumber)
			},
			valueGetter: (params: ValueGetterParams) => {
				const raw =
					params.data?.PhoneNumber ||
					params.data?.MaskedPhoneNumber ||
					"";
				return `${raw} ${UtilityService.maskPhoneNumberOnLength(raw)} ${raw.replace(/\D/g, "")}`;
			},
		},
	]

	const onGridReady = (params) => {
		SetGridApi(params.api);
		SetColumnApi(params.columnApi)
	}


	return (
		<>
			<div className={`d-flex flex-direction w-p-100 ${IsMobileDevice ? "" : "mt-2"}`}>
				<SettingsHeader IsMobileDevice={IsMobileDevice} Title={"Unsubscribed Contacts"} subTitle={"Your unsubscribed contact list"} count={count} />
			</div>
			<div className={`${IsMobileDevice ? "h-v-83" : " d-flex h-p-80 mb-2"}`}>
				<GridComponent
					ColumnDefs={UnsubscribedColoumnDefs}
					RowData={GetUnSubscribedContacts}
					OnGridReady={onGridReady}
					IsPaginationEnabled={false}
					EmptyLabel={"There are no unsubscribed contacts yet!"}
					LockVisible={true}
					IsSettingsGrid
				/>
			</div>
		</>
	)
}

export default UnsubscribedContacts;